function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 16.5,
  stroke: "#073331",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 8.5,
  fill: "#FFD747"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.362 15.305h2.034V24h-2.034v-8.695zm-.485-3.172c0-.423.143-.777.43-1.063a1.453 1.453 0 011.063-.448c.423 0 .777.15 1.063.448.299.286.448.64.448 1.063 0 .41-.15.765-.448 1.064-.286.286-.64.429-1.063.429-.41 0-.765-.143-1.064-.43a1.485 1.485 0 01-.429-1.063z",
  fill: "#1B1E1C"
});

function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgInfoIcon;